__turbopack_context__.v({
  "healthTrackerCard": "HealthTracker-module__ASmX1W__healthTrackerCard",
  "root": "HealthTracker-module__ASmX1W__root",
});
